export const checkIsSmallScreen = () => {
  return window.innerWidth < 996
}
